import type { LegalLocale } from './legal/documents';
import {
  OPERATOR_AR,
  OPERATOR_EN,
  PRODUCT_AR,
  PRODUCT_EN,
  SUPPORT_EMAIL,
  WEBSITE,
} from './legal/identity';

type Copy = Record<string, string>;

const ar: Copy = {
  'nav.home': 'الرئيسية',
  'nav.aria': 'روابط الموقع',
  'nav.lang.label': 'اللغة',
  'home.card.privacy': 'ما نجمعه من بيانات، ولماذا، ومع من نشاركه.',
  'home.card.terms': 'شروط استخدام التطبيق والموقع.',
  'home.card.support': 'كيف تصل إلينا إن احتجت مساعدة.',
  'home.card.deletion': 'احذف حسابك وبياناتك بنفسك.',
  'car.error.title': 'تعذّر تحميل الإعلان',
  'car.error.body': 'تحقّق من اتصالك ثم حاول مرة أخرى.',
  'car.retry': 'إعادة المحاولة',
  'deletion.error.server': 'حدث خطأ من جهتنا. حاول مرة أخرى بعد قليل.',
  'deletion.error.network': 'تعذّر الوصول إلى الخادم. تحقّق من اتصالك ثم حاول مرة أخرى.',
  'deletion.error.passwordRequired': 'أدخل كلمة المرور للتأكيد.',
  'nav.privacy': 'سياسة الخصوصية',
  'nav.terms': 'شروط الاستخدام',
  'nav.support': 'الدعم',
  'nav.deletion': 'حذف الحساب',
  'nav.lang.ar': 'العربية',
  'nav.lang.en': 'English',
  'home.title': PRODUCT_AR,
  'home.subtitle': `تطبيق ${PRODUCT_AR} لوكالة زيوت LOTOS في دير الزور.`,
  'home.lead':
    'هذه الصفحات الرسمية للخصوصية وشروط الاستخدام والدعم وحذف الحساب. لا تحتاج إلى تسجيل الدخول لعرضها.',
  'home.operator': `المشغّل: ${OPERATOR_AR}`,
  // The shared car page. Public, and reachable without an account — the whole
  // point is that somebody who received a link can see the car.
  'car.loading': 'جارٍ التحميل…',
  'car.missing.title': 'هذا الإعلان لم يعد متاحاً',
  'car.missing.body': 'ربما تم بيع السيارة أو إلغاء الإعلان.',
  'car.sold': 'تم بيع هذه السيارة.',
  'car.photoCredit': 'الصورة:',
  'car.odometer': 'الكيلومترات',
  'car.km': 'كم',
  'car.place': 'الموقع',
  // Never the word "موثق": the application records that somebody recorded the
  // work, which is a different claim from the work having been done.
  'car.hasHistory': `لهذه السيارة سجل صيانة داخل ${PRODUCT_AR}.`,
  'car.openApp': 'افتح في التطبيق',
  'notFound.title': 'هذه الصفحة غير موجودة',
  'notFound.body': 'الرابط غير صحيح، أو الصفحة لم تعد متاحة.',
  'notFound.home': 'العودة إلى الرئيسية',
  'support.title': 'الدعم',
  'support.lead': `قناة ${PRODUCT_AR} الرسمية للدعم والخصوصية والبيانات وحذف الحساب هي البريد الإلكتروني.`,
  'support.email': SUPPORT_EMAIL,
  'support.noChat': 'لا توجد حالياً دردشة دعم داخل التطبيق.',
  'support.phoneNote':
    'رقم هاتف المالك الظاهر في الصفحات القانونية هو للتعريف بالأعمال فقط، وليس قناة الدعم أو حذف الحساب.',
  'support.website': WEBSITE,
  'deletion.title': 'حذف حساب الكار كارنا',
  'deletion.lead':
    'هذا مسار حذف الحساب خارج التطبيق. سجّل الدخول ببيانات حسابك الحالية. لا نستخدم رسائل SMS ولا نطلب بريداً إلكترونياً إن كان حسابك يعتمد على رقم الهاتف.',
  'deletion.identifier': 'رقم الهاتف أو البريد الإلكتروني',
  'deletion.password': 'كلمة المرور',
  'deletion.signIn': 'تسجيل الدخول للمتابعة',
  'deletion.signedInAs': 'أنت مسجّل الدخول كـ',
  'deletion.signOut': 'تسجيل الخروج',
  'deletion.meaning.title': 'ماذا يعني الحذف؟',
  'deletion.meaning.access': 'بعد التأكيد النهائي يتوقف الوصول فوراً وتُلغى الجلسات النشطة.',
  'deletion.meaning.personal':
    'تُمحى البيانات الشخصية أو تُجهَّل فوراً على النظام الحي. وقد تستغرق إزالة النسخ الاحتياطية مدة تصل إلى 30 يوماً.',
  'deletion.meaning.retain':
    'قد تُحفظ سجلات محدودة عند لزومها قانوناً أو تجارياً: الطلبات المكتملة، الفواتير، الديون والمقبوضات، سلامة المخزون أو المحاسبة، منع الاحتيال، أو إثبات معاملات تجارية مكتملة.',
  'deletion.meaning.blockers':
    'لا يمكن الحذف إذا بقي رصيد محفظة غير مسوّى، أو تحويل مركبة معلّق، أو إذا كنت آخر مدير.',
  'deletion.confirm.label': 'اكتب أحذف حسابي للتأكيد',
  'deletion.confirm.phrase': 'أحذف حسابي',
  'deletion.submit': 'حذف الحساب نهائياً',
  'deletion.done.title': 'تم استلام طلب الحذف',
  'deletion.done.reference': 'مرجع الطلب',
  'deletion.done.email': 'أرسلنا رسالة تأكيد إلى البريد المسجّل إن وُجد.',
  'deletion.done.noEmail': 'لا يحتاج حساب الهاتف فقط إلى بريد لإكمال الحذف.',
  'deletion.help': `إذا تعذّر إكمال الحذف راسل ${SUPPORT_EMAIL}. لا تُرسل كلمة المرور.`,
  'deletion.error.generic': 'تعذّر تسجيل الدخول. تحقّق من البيانات ثم حاول مرة أخرى.',
  'deletion.error.rate': 'محاولات كثيرة. انتظر قليلاً ثم حاول مرة أخرى.',
  'deletion.error.confirm': 'يجب كتابة عبارة التأكيد تماماً.',
  'deletion.error.blocked': 'لا يمكن حذف هذا الحساب الآن. راسل الدعم إن احتجت مساعدة.',
  'deletion.error.password': 'كلمة المرور غير صحيحة. تحقّق ثم حاول مرة أخرى.',
  'document.version': 'الإصدار {version}',
  'document.updated': 'آخر تحديث: {date}',
  'document.effective': 'ساري من {date}',
  'footer.operator': OPERATOR_AR,
  'footer.product': PRODUCT_AR,
};

const en: Copy = {
  'nav.home': 'Home',
  'nav.aria': 'Site',
  'nav.lang.label': 'Language',
  'home.card.privacy': 'What data we collect, why, and who we share it with.',
  'home.card.terms': 'The terms for using the app and this site.',
  'home.card.support': 'How to reach us if you need help.',
  'home.card.deletion': 'Delete your account and your data yourself.',
  'car.error.title': 'Could not load this listing',
  'car.error.body': 'Check your connection and try again.',
  'car.retry': 'Try again',
  'deletion.error.server': 'Something went wrong on our side. Try again in a moment.',
  'deletion.error.network': 'We could not reach the server. Check your connection and try again.',
  'deletion.error.passwordRequired': 'Enter your password to confirm.',
  'nav.privacy': 'Privacy Policy',
  'nav.terms': 'Terms of Use',
  'nav.support': 'Support',
  'nav.deletion': 'Delete account',
  'nav.lang.ar': 'العربية',
  'nav.lang.en': 'English',
  'home.title': PRODUCT_EN,
  'home.subtitle': `${PRODUCT_EN} — the LOTOS Oils Agency app for Deir ez-Zor.`,
  'home.lead':
    'These are the official Privacy Policy, Terms of Use, Support, and account-deletion pages. You do not need to sign in to read them.',
  'home.operator': `Operator: ${OPERATOR_EN}`,
  'car.loading': 'Loading…',
  'car.missing.title': 'This listing is no longer available',
  'car.missing.body': 'The car may have been sold or the listing withdrawn.',
  'car.sold': 'This car has been sold.',
  'car.photoCredit': 'Photo:',
  'car.odometer': 'Kilometres',
  'car.km': 'km',
  'car.place': 'Location',
  'car.hasHistory': `This car has a service record inside ${PRODUCT_EN}.`,
  'car.openApp': 'Open in the app',
  'notFound.title': 'This page does not exist',
  'notFound.body': 'The link is wrong, or the page is no longer available.',
  'notFound.home': 'Back to the home page',
  'support.title': 'Support',
  'support.lead': `The official ${PRODUCT_EN} channel for support, privacy, data, and account deletion is email.`,
  'support.email': SUPPORT_EMAIL,
  'support.noChat': 'There is currently no in-app support chat.',
  'support.phoneNote':
    'The owner telephone number on the legal pages is business identification only. It is not the support or account-deletion channel.',
  'support.website': WEBSITE,
  'deletion.title': `Delete your ${PRODUCT_EN} account`,
  'deletion.lead':
    'This is the out-of-app account-deletion path. Sign in with your existing credentials. We do not use SMS, and we do not require an email if your account uses a phone number.',
  'deletion.identifier': 'Phone number or email',
  'deletion.password': 'Password',
  'deletion.signIn': 'Sign in to continue',
  'deletion.signedInAs': 'Signed in as',
  'deletion.signOut': 'Sign out',
  'deletion.meaning.title': 'What deletion means',
  'deletion.meaning.access':
    'After final confirmation, access stops immediately and active sessions are revoked.',
  'deletion.meaning.personal':
    'Personal data on the live system is erased or anonymised immediately. Residual copies in backups may take up to 30 days to disappear.',
  'deletion.meaning.retain':
    'Limited records may be kept when legally or commercially necessary: completed orders, invoices, debts or receivables, inventory or accounting integrity, fraud prevention, or proof of completed commercial transactions.',
  'deletion.meaning.blockers':
    'Deletion is blocked while an unsettled wallet balance remains, a vehicle transfer is pending, or you are the last administrator.',
  'deletion.confirm.label': 'Type I delete my account to confirm',
  'deletion.confirm.phrase': 'I delete my account',
  'deletion.submit': 'Delete account permanently',
  'deletion.done.title': 'Deletion request received',
  'deletion.done.reference': 'Request reference',
  'deletion.done.email': 'A confirmation was sent to the registered email address, if one exists.',
  'deletion.done.noEmail': 'Phone-only accounts do not need email to complete deletion.',
  'deletion.help': `If you cannot complete deletion, email ${SUPPORT_EMAIL}. Never send your password.`,
  'deletion.error.generic': 'Could not sign in. Check your details and try again.',
  'deletion.error.rate': 'Too many attempts. Wait a moment and try again.',
  'deletion.error.confirm': 'Type the confirmation phrase exactly.',
  'deletion.error.blocked':
    'This account cannot be deleted right now. Email support if you need help.',
  'deletion.error.password': 'The password is incorrect. Check it and try again.',
  'document.version': 'Version {version}',
  'document.updated': 'Last updated: {date}',
  'document.effective': 'Effective {date}',
  'footer.operator': OPERATOR_EN,
  'footer.product': PRODUCT_EN,
};

const dictionaries: Record<LegalLocale, Copy> = { ar, en };

export function t(locale: LegalLocale, key: string, vars?: Record<string, string>): string {
  let value = dictionaries[locale][key] ?? key;
  if (vars) {
    for (const [name, replacement] of Object.entries(vars)) {
      value = value.replaceAll(`{${name}}`, replacement);
    }
  }
  return value;
}
